import { render } from "./quiz-question.vue?vue&type=template&id=259b1692&ts=true"
import script from "./quiz-question.vue?vue&type=script&lang=ts"
export * from "./quiz-question.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__